<div class="d-flex align-items-center justify-content-between mb-4">
    <h6 class="montserrat-medium text-gray-500">Campaign overview</h6>
    <div>
        <!--    <button class="btn btn-lg btn-outline-gray-500 mr-3">-->
        <!--      download summary-->
        <!--    </button>-->
        <button class="btn btn-lg btn-gray-500" (click)="publishCampaign()">
            publish campaign
        </button>
    </div>
</div>
<div class="d-xl-flex align-items-start justify-content-between">
    <app-highlights></app-highlights>
    <div class="flex-grow-1 mx-xl-3">
        <div class="row">
            <!--      <div class="col-12 col-xl-6 h-100 mb-4">-->
            <!--        <div class="bloc-title mb-3">Overall Performance View</div>-->
            <!--        <div class="chart-holder h-100 p-3">-->
            <!--          <div class="d-flex justify-content-between align-items-end mb-3">-->
            <!--            <h4 class="text-gray-500 montserrat-bold">Overall Plays</h4>-->
            <!--          </div>-->
            <!--          <h6 class="text-gray-500 mb-5">January 2020</h6>-->
            <!--          <app-statistics-chart-->
            <!--            [barChartLabels]="playsLabels"-->
            <!--            [data]="playsData"-->
            <!--          ></app-statistics-chart>-->
            <!--        </div>-->
            <!--      </div>-->
            <!--      <div class="col-12 col-xl-6 h-100 mb-4">-->
            <!--        <div class="bloc-title mb-3">Overall Performance View</div>-->
            <!--        <div class="chart-holder h-100 p-3">-->
            <!--          <div class="d-flex justify-content-between align-items-end mb-3">-->
            <!--            <h4 class="text-gray-500 montserrat-bold">Reach View</h4>-->
            <!--          </div>-->
            <!--          <h6 class="text-gray-500 mb-5">January 2020</h6>-->
            <!--          <app-statistics-chart-->
            <!--            [barChartLabels]="reachLabels"-->
            <!--            [data]="reachData"-->
            <!--          ></app-statistics-chart>-->
            <!--        </div>-->
            <!--      </div>-->
            <div class="col-12 mb-4">
                <div class="bloc-title mb-3">Campaign Overview</div>
                <div class="bg-gray-200 p-3 br-15">
                    <app-campaign-overview></app-campaign-overview>
                </div>
            </div>
            <div class="col-12 mb-4">
                <div class="bloc-title mb-3">Media Overview</div>
                <div class="bg-gray-200 p-3 br-15">
                    <app-media-overview></app-media-overview>
                </div>
            </div>
            <div class="col-12">
                <div class="bloc-title mb-3">Performance/Channel</div>
                <div class="bg-gray-200 p-3 br-15">
                    <app-channel-performance></app-channel-performance>
                </div>
            </div>
        </div>
    </div>
</div>
